<template>
  <div class="chat" :class="{open: isOpen}" v-if="scenarioData">
    <div class="controls">
      <button @click="$emit('close')">
        <i class="material-icons" v-if="isOpen">close</i>
      </button>
    </div>

    <div class="title">
      <h2>Ask the trainer ({{scenarioData.trainer.name}})</h2>
      <h3>About {{scenarioData.name}}</h3>
    </div>

    <transition-group name="note" tag="div" class="messages">
      <div 
        v-for="message in messages" 
        :key="message.id" 
        :class="{me:message.from =='me'}" 
        class="message rounded">
        <div class="text">{{message.message}}</div>
        <div class="from">{{message.from}}</div>
      </div>
    </transition-group>
    
    <form @submit.prevent="addMessage" class="textbox">
      <input type="text" v-model="newMessage.message" placeholder="Message">
      <button  class="add-button btn light inverted"><i class="material-icons">send</i> <span>Send</span></button>
    </form>
    
  </div>
</template>

<script>
var _ = require('lodash');
import { scenarioMixin } from '@/mixins/scenarioMixin.js'
export default {
  name: "Chat",
  mixins: [scenarioMixin],
  props: {
    openDrawer: {
      type: String,
    },
  },
  data () {
    return {
      newMessage: {
        from: "me",
        message: ""
      }
    }
  },
  created () {
  },
  computed: {
    isOpen () {
      return (this.openDrawer === "chat" ? true : false)
    },
    messages () {
      if ( this.isOpen ) {
        return this.$store.getters["chatModule/getMessages"](this.scenarioData.id)
      } else {
        return []
      }
    }
  },
  methods: {
    // setNotesDebounce:_.debounce(function(){
    //   this.setNotes()
    // }, 2000),
    // setNotes () {
    //   this.$store.dispatch('chatModule/setNotes', this.messages)
    // },
    addMessage () {
      this.newMessage.sid = (this.scenarioData ? this.scenarioData.id : null)
      this.$store.dispatch('chatModule/addMessage', this.newMessage).then(() => {
        // console.log(prevMsg)
        this.newMessage.message = ""

        setTimeout(() => {
          this.simTrainerMessage()
        }, 2500);

      })
    },
    removeNote (message) {
      this.$store.dispatch('chatModule/removeMessage', message)
    },
    simTrainerMessage () {
      const messages = [
        "Hello, I am here to help",
        "Thank you for the valuable feedback",
        "This is the way you should look at it",
        "Sorry, I cannot help you with that right now",
        "Have a nice day!",
        "Let me get back to you in a minute",
        "Please refer to the documentation",
        "Always a pleasure!",
        "Hey, how are you doing?",
        "Good to hear"
      ]
      let simMessage = {
        from: this.scenarioData.trainer.name,
        sid: this.scenarioData.id,
        message: _.sample(messages)
      }
      this.$store.dispatch('chatModule/addMessage', simMessage)
    }
  },
  watch: {
    isOpen (status) {
      if ( status ) {
        this.$store.dispatch('chatModule/loadMessages', this.scenarioData)
      }
    }
  },
};
</script>

<style lang="scss" scoped>

  .chat {
    display: grid;
    grid-template-areas: 
      ". title controls"
      ". ..... ........"
      ". messages ......"
      ". textbox ......";
    grid-template-columns: 25px 1fr 50px;
    grid-template-rows: 70px 62px 1fr auto;
    position: absolute;  
    z-index: 400;
    top: 0;
    left: 0;
    width: 40vw;
    min-width: 350px;
    padding: 22px 0 25px;


    transform: translateX(-100%);
    transition: all 0.25s cubic-bezier(0.4, 0.0, 0.2, 1);

    &.open {
      position: fixed;
      height: 100vh;
      transform: translateX(0);
      transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
      background-color: darken(#3d3dde, 20%);
    }

    @media all and (min-width: 768px) {
      // background-color: darken(#3d3dde, 20%);
      // position: fixed;
      height: 100vh;
    }
  }
  .controls {
    grid-area: controls;
    // text-align: center;
    justify-content: flex-start;
    display: flex;

    button {
      background: none;
      border: none;
      color: #fff;
      width: 20px;
      padding: 0;
    }
    .open-item {
      margin-left: 10px;
    }
  }

  .title {
    grid-area: title;
    color: #fff;
    align-self: center;
  }

  .messages {
    grid-area: messages;
    overflow: scroll;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    overflow: scroll;

    .message {
      position: relative;
      display: inline-block;
      margin-bottom: 1em;
      width: 80%;
      padding: 15px 15px 10px;
      background-color: #fff;
      white-space: pre;
      flex-shrink: 0;

      .from {
        font-size: 13px;
        color: rgb(134, 133, 133);
        text-align: right;
      }

      // &::after {
      //   content: "";
      //   position: absolute;
      //   top: 0;
      //   width: 0;
      //   height: 0;
      //   border-style: solid;
      // }

      &.me {
        align-self: flex-end;
        background-color:rgba(#fff, 0.85);

        // &::after {
        //   content: "";
        //   left: 100%;
        //   border-width: 30px 30px 0 0;
        //   border-color: #ffffff transparent transparent transparent;
        // }
      }
      &:not(.me) {
        // &::after {
        //   content: "";
        //   right: 100%;
        //   border-width: 0 30px 30px 0;
        //   border-color: transparent #ffffff transparent transparent;
        // }
      }
    }
  }
  
  .textbox {
    grid-area: textbox;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    input[type="text"],
    textarea {
      resize: vertical;
      background-color: rgba(#fff, 0.85);
      color: #1a1a9b;
      border: 1px solid transparent;
      font-size: 15px;
      font-family: 'Kalam', cursive;
      margin-bottom: 0.5em;
      padding: 5px;

      &::selection {
        background-color: #e1651d;
      }

      &:focus {
        outline: none;
        border-color: #e1651d;
      }
    }

    button {
      align-self: flex-end;
    }
  }
  .add-button {
    display: inline-flex;
    // justify-self: flex-end;
  }

  hr {
    height: 0;
    border: 0;
    border-top: 2px solid #7474CA;
    flex: 1;
  }
  
</style>